import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../../recoil/auth";
import { getChargeHistoryAPI } from "../../../../../api";

const ChargeStatus = ({ onTabChange }) => {
  const user = useRecoilValue(userState);
  const [chargeHistory, setChargeHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 목데이터
  const mockChargeHistory = [
    {
      id: 1,
      date: "08.20",
      amount: "1,000,000원",
      status: "지급완료",
      statusType: "completed",
    },
    {
      id: 2,
      date: "08.19",
      amount: "500,000원",
      status: "입금대기중",
      statusType: "pending",
    },
    {
      id: 3,
      date: "08.18",
      amount: "200,000원",
      status: "거절",
      statusType: "rejected",
    },
  ];

  // 날짜 포맷팅 함수
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}.${day}`;
  };

  // 금액 포맷팅 함수
  const formatAmount = (amount) => {
    return `${amount.toLocaleString()}원`;
  };

  // 상태 변환 함수
  const getStatusText = (status) => {
    switch (status) {
      case "APPROVED":
        return "지급완료";
      case "PENDING":
        return "입금대기중";
      case "REJECTED":
        return "거절";
      default:
        return status;
    }
  };

  const getStatusType = (status) => {
    switch (status) {
      case "APPROVED":
        return "completed";
      case "PENDING":
        return "pending";
      case "REJECTED":
        return "rejected";
      default:
        return "pending";
    }
  };

  // 충전 내역 데이터 로딩
  useEffect(() => {
    const loadChargeHistory = async () => {
      if (!user?.id) {
        // 로그인되지 않은 경우 목데이터 사용
        setChargeHistory(mockChargeHistory);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await getChargeHistoryAPI({
          web_member_id: user.id,
          page: 1,
          pageSize: 3,
        });

        if (response.data?.list) {
          const formattedData = response.data.list.map((item) => ({
            id: item.id,
            date: formatDate(item.created_at),
            amount: formatAmount(item.amount),
            status: getStatusText(item.status),
            statusType: getStatusType(item.status),
          }));
          setChargeHistory(formattedData);
        } else {
          setChargeHistory([]);
        }
      } catch (error) {
        console.error("ChargeStatus: 충전 내역 로딩 실패", error);
        setError("충전 내역을 불러오는 중 오류가 발생했습니다.");
        setChargeHistory([]);
      } finally {
        setLoading(false);
      }
    };

    loadChargeHistory();
  }, [user?.id]);

  return (
    <div className="dashboard-widget-card-harf dashboard-charge-status-card">
      <div className="dashboard-card-header">
        <h3>충전 내역</h3>
        <button
          className="dashboard-more-link"
          onClick={() => {
            if (onTabChange) {
              onTabChange("deposit", "chargeHistory");
            }
          }}
        >
          더보기 &gt;
        </button>
      </div>
      <ul className="dashboard-charge-list">
        {loading ? (
          <li style={{ padding: "20px", textAlign: "center", color: "#666" }}>
            로딩 중...
          </li>
        ) : error ? (
          <li style={{ padding: "20px", textAlign: "center", color: "red" }}>
            {error}
          </li>
        ) : chargeHistory.length > 0 ? (
          chargeHistory.map((item) => (
            <li key={item.id}>
              <div className="charge-info">
                <span className="date">{item.date}</span>
                <span className="amount" style={{ marginLeft: "12px" }}>
                  {item.amount}
                </span>
              </div>
              <span className={`dashboard-status-badge ${item.statusType}`}>
                {item.status}
              </span>
            </li>
          ))
        ) : (
          <li style={{ padding: "20px", textAlign: "center", color: "#666" }}>
            충전 내역이 없습니다.
          </li>
        )}
      </ul>
    </div>
  );
};

export default ChargeStatus;
